import {observer} from "mobx-react"
import {useEffect, useState} from "react"
import {Category} from "dto/category/category"
import {calculateDeviceStatus, Counter, newCounter} from "store/dashboard/DashboardStore"
import {isEmergencyStatus, isErrorStatus, isNoneOperationStatus, RealDevice} from "dto/realdevice/devices"
import TtlDeviceStatusCounterPanel from "pages/dashboard/ttl-status/TtlDeviceStatusCounterPanel"
import DeviceStatusSummaryCard from "pages/dashboard/ttl-status/DeviceStatusSummaryCard"


type Props = {
    selectedCategory: Category
    allCategories: Category[]
    devices: RealDevice[]
    onBackButtonClick: () => void
}

function calculateStatus(parentStatusMap: Map<number, Counter>, parentId: number, device: RealDevice) {
    const parentStatus = parentStatusMap.get(parentId) || newCounter()

    parentStatus.ttlCount = parentStatus.ttlCount + 1
    calculateDeviceStatus(device, parentStatus)
    return parentStatus
}

const SecondLevelDeviceStatusView = observer(({devices, allCategories, selectedCategory, onBackButtonClick}: Props) => {
    // const [parentCategoryMap, setParentCategoryMap] = useState<Map<number, Category>>(new Map())
    const [childCategoryMap, setChildCategoryMap] = useState<Map<number, Category>>(new Map())
    const [parentFinderMap, setParentFinderMap] = useState<Map<number, number>>(new Map())
    const [parentStatusMap, setParentStatusMap] = useState<Map<number, Counter>>(new Map())
    // const {dashboardStore: {counter}} = useRootStore()

    useEffect(() => {
        if (!allCategories) return
        // const parentCategoryMap = new Map<number, Category>()
        const childCategoryMap = new Map<number, Category>()
        // const parentFinderMap = new Map<number, number>()
        allCategories
            .forEach((category: Category) => {
                if (!category.id) return
                if (category.level === "DISTRICT" && category.parentId === selectedCategory.id) {
                    childCategoryMap.set(category.id, category)
                }
            })
        // setParentCategoryMap(parentCategoryMap)
        // setParentFinderMap(parentFinderMap)
        setChildCategoryMap(childCategoryMap)
    }, [allCategories])

    useEffect(() => {
        const parentStatusMap = new Map<number, Counter>()
        devices.filter((device) => {
            return device.category?.parentId === selectedCategory.id
        }).forEach((device) => {
            if (device.category?.id) {
                // const parentId = parentFinderMap.get(device.category.id)
                // if (parentId) {
                const parentStatus = calculateStatus(parentStatusMap, device.category.id, device)

                parentStatusMap.set(device.category.id, parentStatus)
                // }
            }
            setParentStatusMap(parentStatusMap)
        })
    }, [devices, selectedCategory])


    const counter = Array.from(childCategoryMap.values()).map((category: Category) => {
        return parentStatusMap.get(category.id || 0) || newCounter()
    }).reduce((prev, curr) => {
        prev.count = prev.count + 1
        prev.normalCount = prev.normalCount + curr.normalCount
        prev.emergencyCount = prev.emergencyCount + curr.emergencyCount
        prev.errorCount = prev.errorCount + curr.errorCount
        prev.workingCount = prev.workingCount + curr.workingCount
        prev.powerOffCount = prev.powerOffCount + curr.powerOffCount
        prev.noneOperationCount = prev.noneOperationCount + curr.noneOperationCount
        prev.ttlCount = prev.ttlCount  + curr.ttlCount


        return prev
    }, newCounter())
    return (
        <div className="column body-operation" style={{height: '90%'}}>
            <div>
                <h1 className="title has-text-info ml10 mt10">
                    <button className="button is-outlined is-rounded is-size-85 is-White mt5 mr-3"
                            onClick={() => onBackButtonClick()}
                    >
                        <i className="fas fa-backward"></i>
                    </button>
                    <span className="has-text-warning is-size-2">전동 휠체어 </span>
                    {/*<span className="ml5">지역(카테고리)별 장비현황</span>*/}
                    <span className="ml5">{selectedCategory.name}</span>
                </h1>
            </div>
            <div className="columns is-variable bd-klmn-columns is-5 mt10 p10">
                <TtlDeviceStatusCounterPanel counter={counter}/>
            </div>
            <div className="columns is-variable bd-klmn-columns is-5 p10 is-multiline">
                {Array.from(childCategoryMap.values()).map((category: Category) => {
                    const areaCounter = parentStatusMap.get(category.id || 0) || newCounter()
                    return <DeviceStatusSummaryCard key={category.id} label={category.name} counter={areaCounter}/>
                })}
            </div>
        </div>
    )
})

export default SecondLevelDeviceStatusView